export default {
    validation: {
        requiredJudet: 'Inregistrarea judetului este obligatorie',
        requiredLocal: 'Inregistrarea localitatii este obligatorie',
        required: 'Inregistrarea {field} este obligatorie',
        email: 'Adresa de e-mail trebuie sa fie valida',
        customRequired: {
            name: 'Numele este necesar',
            surname: 'Prenumele este necesar',
            email: 'Adresa de e-mail este necesara',
            terms: 'Termenii si conditiile sunt necesare',
            verificationCode: 'Inregistrarea Cod de verificare este obligatorie',
            gender: 'Inregistrarea sexului este obligatorie',
            confirmEmail: 'Adresa de e-mail trebuie confirmata',
            mobile: 'Numarul de telefon este necesar',
            cnp: 'Inregistrarea CNP-ului este obligatorie',
            cnpConfirm: 'Confirmarea CNP-ului este obiligatorie',
            returnReason:'Inregistrarea motivului returului este obligatorie',
            gdpr: 'Campul este obligatoriu'
        },
        customLength: {
            phoneNumber: 'Campul trebuie sa contina {length} cifre',
            verificationCode: 'Codul de verificare trebuie sa aiba {length} cifre',
            digit: 'Campul Cod Postal trebuie sa fie numeric si sa contina exact 6 cifre',
            postal: 'Codul Postal trebuie format din 6 cifre',
            cnp: 'CNP-ul nu este valid',
            returnReason: 'Este necesar un câmp cu minim 20 max 200 de caractere pentru răspunsul utilizatorului'
        },
        customInteger: {
            phoneNumber: 'Te rugam sa introduci un numar de telefon valid',
            verificationCode: 'Cod de verificare invalid',
            postal: 'Codul Postal nu este valid',
            cnp: 'CNP-ul nu este valid'
        },
        customAlpha: {
            name: 'Prenume trebuie sa fie valida',
            surname: 'Nume trebuie sa fie valida'
        },
        customPhoneNumber: {
            mobile: 'Numarul de telefon nu este valid',
            verificationCode: 'Codul de verificare trebuie sa aiba {digits} cifre'
        }
    }
}